import TypingActivityHelper from 'mixins/TypingActivityHelper';
import CommonAudio from 'mixins/CommonAudio';
import { activityTyping, mapMutations } from '../../store/helpers';
import mixins from 'vue-typed-mixins';
const BACKSPACE = 'backspace';
const CLEAR = 'clear';
const AnswerInput = mixins(TypingActivityHelper, CommonAudio).extend({
    props: {
        answer: {
            type: String,
            default: ''
        },
        maxLength: {
            type: Number,
            default: 3000
        },
        autoFocus: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            focused: false,
            answerLocal: '',
            answerIndex: 0,
            innerTransition: 'fade-10'
        };
    },
    computed: {
        showCursor() {
            return this.focused && this.answerLocal.length <= this.maxLength;
        },
        splitWords() {
            const words = (this.answer || this.answerLocal).split(' ').map(text => ({
                text: text.trim()
            }));
            let prevStartingIndex = null;
            words.forEach((w, i) => {
                const word = words[i];
                if (!prevStartingIndex) {
                    prevStartingIndex = 0;
                }
                word.startingIndex = prevStartingIndex;
                // add space that was removed by split, except for last element
                word.text = i === words.length - 1 ? word.text : word.text.concat(' ');
                prevStartingIndex += word.text.length;
            });
            return words;
        }
    },
    created() {
        this.setFreeTextTyping(true);
    },
    mounted() {
        if (this.autoFocus && !this.disabled) {
            this.focus();
        }
    },
    methods: Object.assign(Object.assign({}, mapMutations(activityTyping, ['setFreeTextTyping'])), { getClass(word, letterIndex) {
            const lettersTyped = this.splitWords.reduce((acc, array) => acc + array.text.length, 0);
            const emptyTyping = lettersTyped === 1 ? 'empty' : '';
            const emptyWords = word === ' ' ? 'white-space wrap-initial' : '';
            return [
                `char${letterIndex + 1}`,
                'white-space',
                letterIndex < this.answerIndex ? 'answer-correct-letter' : '',
                emptyTyping,
                emptyWords
            ];
        },
        handleKeyPressWithAnswer(character) {
            const correctCharacter = this.answer.charAt(this.answerIndex);
            if (correctCharacter === character && this.answerLocal.length < this.answer.length) {
                this.answerIndex += 1;
                this.answerLocal = `${this.answerLocal}${character}`;
                this.$emit('input', this.answerLocal);
            }
            else {
                this.sndError();
            }
        },
        handleKeyPress(character) {
            const lowerChr = character.toLowerCase();
            if (lowerChr === BACKSPACE) {
                // remove last character if backspace
                this.answerLocal = this.answerLocal.slice(0, -1) || ' ';
            }
            else {
                if (this.answerLocal === ' ') {
                    this.answerLocal = '';
                }
                this.answerLocal = `${this.answerLocal}${character}`;
            }
            if (lowerChr === CLEAR) {
                this.answerLocal = '';
            }
            const self = this;
            this.$nextTick(() => {
                // scroll to component
                const answerDomElement = this.$refs.answerDomElement;
                answerDomElement.scrollTop = answerDomElement.offsetHeight;
                if (this.answerLocal.length > this.maxLength) {
                    this.sndError();
                    setTimeout(() => {
                        self.answerLocal = self.answerLocal.slice(0, -1);
                    }, 200);
                }
                else {
                    this.$emit('input', this.answerLocal);
                }
            });
        },
        handleCorrectKey({ character }) {
            if (!this.focused)
                return;
            if (this.answer) {
                this.handleKeyPressWithAnswer(character);
            }
            else {
                this.handleKeyPress(character);
            }
        },
        handleClick() {
            this.focus();
        },
        focus() {
            if (this.disabled)
                return;
            const answerDomElement = this.$refs.answerDomElement;
            answerDomElement.focus();
            this.focused = true;
        },
        blur() {
            this.focused = false;
        },
        handleFocusOut(e) {
            if (!e.relatedTarget || !e.relatedTarget.dataset.isfocusable) {
                this.focus();
                return;
            }
            this.focused = false;
        } }),
    watch: {
        disabled(newVal) {
            if (newVal) {
                this.focused = false;
            }
        },
        answer(newVal, oldVal) {
            if (!oldVal && newVal) {
                this.answerLocal = '';
            }
        }
    }
});
export default AnswerInput;
